import React, { useEffect, useState, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";

import { loginRequest } from "../authConfig";

import "../styles/DirectReports.css";
import { Form, Modal, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import { offBoardUser, updateUserAPI } from "../graph";
import { Context } from "../Context";

import "../styles/ModalViewDetailsOffboard.css";
import { ProfileData } from "./ProfileData";

/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const ModalViewDetailsOffboard = (props) => {
    const { instance, accounts } = useMsal();
    const [showOffBoard, setShowOffboard] = useState(false);
    const [offboardValidated, setOffboardValidated] = useState(false);
    const [updateValidated, setUpdateValidated] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [messageAPI, setMessageAPI] = useState('');
    const [, setIsLoading] = useContext(Context);

    const [showViewDetailsPage, setShowViewDetailsPage] = useState(false);
    const [showOptionsEmployee, setShowOptionsEmployee] = useState(!!props.user)

    const offboardUser = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity()) {
            // Silently acquires an access token which is then attached to a request for MS Graph data
            instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            }).then((response) => {
                setIsLoading(true);
                const leavingDate = new Date(form.dateLeaving.value).toISOString();
                const leavingReason = form.reasonLeaving.value;
                offBoardUser(response.accessToken, props.user.id, leavingDate, leavingReason)
                    .then(() => {
                        setIsLoading(false);
                        props.onUpdateEmployee({
                            ...props.user,
                            exts5qeux5w_WiderTeam: {
                                ...props.user.exts5qeux5w_WiderTeam,
                                terminationDate: leavingDate,
                                terminationReasonDescription: leavingReason
                            }
                        });
                        setShowOffboard(false);
                        setMessageAPI('User successfully offboarded')
                        setShowToast(true);
                    })
                    .catch(error => {
                        props.onClose();
                        setIsLoading(false);
                        setShowOffboard(false);
                        setMessageAPI(`Error, ${error}`)
                        setShowToast(true);
                    });
            });
        }

        setOffboardValidated(true);
    };

    const updateUser = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (!confirm('Are you sure you want to update this user?')) {
            return;
        }

        if (form.checkValidity()) {
            // Silently acquires an access token which is then attached to a request for MS Graph data
            instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            }).then((response) => {
                setIsLoading(true);
                const valuesToUpdate = {
                    employeeHireDate: `${form.hiredOn.value}T00:00:00Z`,
                    jobTitle: form.position.value,
                    department: form.department.value,
                    mobilePhone: form.phoneNumber.value === '' ? null : form.phoneNumber.value,
                    exts5qeux5w_WiderTeam: {
                        HomeOrg: form.homeOrg.value,
                        terminationDate: form.terminationDate ? `${form.terminationDate.value}T00:00:00Z` : undefined,
                        terminationReasonDescription: form.terminationReason?.value,
                        emergencyContactName: form.emergencyContactName.value,
                        emergencyPhoneNumber: form.emergencyPhoneNumber.value,
                        fullTimeEquivalents: form.fullTimeEquivalents.value,

                    }
                }

                updateUserAPI(response.accessToken, props.user.id, valuesToUpdate)
                    .then(() => {
                        setIsLoading(false);
                        props.onUpdateEmployee({
                            ...props.user,
                            ...valuesToUpdate,
                            exts5qeux5w_WiderTeam: {
                                ...props.user.exts5qeux5w_WiderTeam,
                                ...valuesToUpdate.exts5qeux5w_WiderTeam
                            }
                        });
                        setShowViewDetailsPage(false);
                        setMessageAPI('User successfully updated')
                        setShowToast(true);
                    })
                    .catch(error => {
                        props.onClose();
                        setIsLoading(false);
                        setShowViewDetailsPage(false);
                        setMessageAPI(`Error, ${error}`)
                        setShowToast(true);
                    });
            });
        }

        setUpdateValidated(true);
    };

    const showOffboardForm = () => {
        setShowOptionsEmployee(false);
        setOffboardValidated(false);
        setShowToast(false);
        setShowOffboard(true);
    };

    const showViewDetails = () => {
        setShowOptionsEmployee(false);
        setUpdateValidated(false);
        setShowToast(false);
        setShowViewDetailsPage(true);
    };

    useEffect(() => {
        if (props.user && props.user.exts5qeux5w_WiderTeam && props.user.exts5qeux5w_WiderTeam.terminationDate) {
            setShowOptionsEmployee(false);
            setShowOffboard(false);
            setUpdateValidated(false);
            setShowViewDetailsPage(true);
            setShowToast(false);
        } else {
            setShowOptionsEmployee(!!props.user);
            setShowOffboard(false);
            setShowViewDetailsPage(false);
        }
    }, [props.user]);

    const onClose = () => {
        setShowOffboard(false);
        setShowOptionsEmployee(false);
        setShowViewDetailsPage(false);
        setOffboardValidated(false);
        setUpdateValidated(false);
        props.onClose();
    };

    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow = tomorrow.toLocaleDateString('en-GB').split('/');

    return (
        <>
            <Modal
                show={showOptionsEmployee}
                onHide={onClose}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header className="removeBorder" closeButton>
                    <Modal.Title>Select an action</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Button variant="success" onClick={showViewDetails}>View details</Button>
                    <Button variant="danger" onClick={showOffboardForm}>Offboard</Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showOffBoard}
                onHide={onClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Form noValidate validated={offboardValidated} onSubmit={offboardUser}>
                    <Modal.Header closeButton>
                        <Modal.Title>Select a date and reason to offboard {props.user?.givenName} {props.user?.surname}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="formGroupReason">
                                    <Form.Label>Reason for leaving</Form.Label>
                                    <Form.Select name="reasonLeaving" required size="sm" aria-label="Reason for leaving">
                                        <option value=""></option>
                                        <option value="Returning to Home Org">Returning to Home Org</option>
                                        <option value="Redundancy">Redundancy</option>
                                        <option value="Voluntary Termination">Voluntary Termination</option>
                                        <option value="Involuntary Termination">Involuntary Termination</option>
                                        <option value="Resignation of employment">Resignation of employment</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        Please select a leaving reason
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3" controlId="formGroupDate">
                                    <Form.Label>Last date</Form.Label>
                                    <Form.Control name="dateLeaving" required type="date" min={`${tomorrow[2]}-${tomorrow[1]}-${tomorrow[0]}`} />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide the last date
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={onClose}>Cancel</Button>
                        <Button variant="danger" type="submit">Offboard</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal
                show={showViewDetailsPage}
                onHide={onClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Form noValidate validated={updateValidated} onSubmit={updateUser}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span>Details of {props.user?.givenName} {props.user?.surname}</span>
                            <span className={`headerTitle employeeStatus status-${props.user?.exts5qeux5w_WiderTeam?.accountStatus}`}>{props.user?.exts5qeux5w_WiderTeam?.accountStatus}</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ProfileData user={props.user} editable={props.editable} />
                    </Modal.Body>
                </Form>
            </Modal>

            <ToastContainer className="p-3" position="top-center" >
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} bg="light" autohide={messageAPI.substr(0, 6) !== 'Error,'}>
                    <Toast.Header>
                        {messageAPI.substr(0, 6) === 'Error,' && <strong>Something went wrong</strong>}
                    </Toast.Header>
                    <Toast.Body>{messageAPI}</Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
};